// src/api/excelAPI.js
import axiosInstance from '../utils/axios';

const excelAPI = {
    importData: (file) => {
        const formData = new FormData();
        formData.append('file', file); // 👈 penting: nama field HARUS sama seperti di Laravel (file)

        return axiosInstance.post('/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    importInitialData: (file) => {
        const formData = new FormData();
        formData.append('file', file); // 👈 penting: nama field HARUS sama seperti di Laravel (file)

        return axiosInstance.post('/import/initial-data', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    importDeposit: (file) => {
        const formData = new FormData();
        formData.append('file', file); // 👈 penting: nama field HARUS sama seperti di Laravel (file)

        return axiosInstance.post('/import/deposit', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    exportHistoryDepositUser: (id, start_date, end_date) => axiosInstance.get('/export/history-depo', { responseType: 'blob', params: { user_id: id, start_date, end_date } }),

    exportHistoryDeposit: (start_date, end_date, search) => axiosInstance.get('/export/history-depo', { responseType: 'blob', params: { start_date, end_date, search } }),

    exportDepositUser: () => axiosInstance.get('/export', { responseType: 'blob' }),

    exportDepositSite: () => axiosInstance.get('/export/site', { responseType: 'blob' }),
};

export default excelAPI;
